import { useContext } from "react";
import { CommonPropsContext } from "../contexts/CommonPropsContext";
import Order from "./Order";

const OrderIndex = () => {
  const { dbConnections, loadingContext } =
    useContext(CommonPropsContext);

  return (
    <>
      {!loadingContext ? (
        <>
          {dbConnections &&
            dbConnections.map((connection_key, index) => (
              <div key={index}>
                <Order connection_key={connection_key} />
              </div>
            ))}
        </>
      ) : (
        <div id="loader"></div>
      )}
    </>
  );
};

export default OrderIndex;
